import { useEffect } from 'react';
import { useGeolocated } from 'react-geolocated';
import { useAppDispatch } from './useAppDispatch';
import { useAppSelector } from './useAppSelector';
import { moveMapTo } from '../store/slices/map';

export const useCoordsRetriever = () => {
    const dispatch = useAppDispatch();
    const map = useAppSelector((state) => state.map);
    const { isCenterAvailable } = map;

    useGeolocated({
        positionOptions: {
            enableHighAccuracy: false,
        },
        userDecisionTimeout: 5000,
    });

    useEffect(() => {
        const getCoordinates = (position: GeolocationPosition) => {
            console.log('Storing device center just approved.');
            if (!isCenterAvailable) {
                dispatch(
                    moveMapTo({
                        center: {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        },
                    })
                );
            } else {
                console.log('Center already stored.');
            }
        };

        const handleError = (error: GeolocationPositionError) => {
            console.error('Error getting location:', error);
        };

        const pollPermissions = () => {
            navigator.permissions.query({ name: 'geolocation' })
                .then((permissionStatus) => {
                    const isGranted = permissionStatus.state === 'granted';

                    if (isGranted) {
                        navigator.geolocation.getCurrentPosition(getCoordinates, handleError);
                    } else {
                        setTimeout(pollPermissions, 1000); // No async/await here
                    }
                })
                .catch((error) => {
                    console.error('Permission query failed:', error);
                });
        };

        if ('permissions' in navigator) {
            pollPermissions();
        } else {
            console.error('Permissions API is not supported by this browser');
        }
    }, []);

    // This runs after the 'rehydrate', so I should have some center by now?
    // useEffect(() => {
    //   if (coords && !isCenterAvailable) {
    //     console.log('Storing device center already approved.');
    //     dispatch(storeDeviceCenter(coords));
    //   }
    // }, [coords]);
    // TODO: review
};
